// Program Offerings Images
import SmartScaleImage from '../assets/images/programs/liver-forever-program/program-offerings/devices.png'
import NutritionistImage from '../assets/images/programs/liver-forever-program/program-offerings/nutritionist-consultation.png'
import PhysiotherapistImage from '../assets/images/programs/liver-forever-program/program-offerings/physio-consultation.png'
import LipaglynImage from '../assets/images/programs/liver-forever-program/program-offerings/lipaglyn-strips.png'
import constants from '../constants'
import FullName from '../components/Signup/FullName'

// Services Icons
import CalenderIcon from '../assets/icons/calender.svg'

// Logo Images
import LiverForeverLogoWhite from '../assets/images/logos/liver-forever-logo-white.png'
import WomanThumbsUp from '../assets/images/success/woman-thumbs-up.png'
import { ANAYA_CONFIG } from './anaya-configs'
import { VIEMAX } from './viemax-configs'
import { DIASENS_CONFIG } from './diasens-configs'
import { GOODFLIP_CONFIG } from './goodflip-configs'
import { GLUCOLIVE_CONFIG } from './glucolive-configs'

export const supportProgramStatus = {
  DOCUMENT_REVIEW_STATUS: {
    UNDER_REVIEW: 'Under Review',
    REJECTED: 'Rejected',
    APPROVED: 'Approved',
  },
}

export const supportProgramTypes = {
  [constants.CARE_PROGRAM_TYPE.LIVER_FOREVER_PROGRAM]: {
    id: 'liver-forever-program',
    name: 'Liver Forever Program',
    drug_name: 'Lipaglyn',
    medical_condition_group_id: '0c01eae6-624a-11ec-9077-ab9c0a5eb881',
    campaign_link: `${process.env.REACT_APP_FE_URL}/programs/liver-forever-program`,
    logoWhite: LiverForeverLogoWhite,
    partnerName: 'LiverForever',
    services: [
      {
        icon: CalenderIcon,
        name: 'Book Appointment',
        description: 'With Nutritionist, Physio and Success Coach',
        message_to_rn: 'BOOK_APPOINTMENT',
      },
    ],
    onboarding_steps: [{ name: 'name', hideButton: true, Component: FullName }],
    success_image: WomanThumbsUp,
    success_image_width: 220,
    // steps: ['documents'], // ['documents', 'address'],
    steps: [
      {
        id: 'documents',
        name: 'Upload Documents',
        description: 'Upload the following document(s) to enter the program',
        upload_report_type: 'liver_forever_report',
        document_types: [
          { document_type: 'pi', document_title: 'Purchase Invoice' },
          { document_type: 'dp', document_title: 'Prescription' },
        ], //  ['ds', 'pi', 'dp', 'us'],
      },
      // {
      //   id: 'address',
      //   name: 'Enter Address',
      //   description: 'Enter your address to receive your care coins',
      // },
    ],
    success_message: () => (
      <>
        Powered by <b>GoodFlip</b> in partnership with
        <br /> <b>LiverForever</b>. A trusted liver health initiative.
      </>
    ),

    offerings: [
      {
        image: SmartScaleImage,
        title: 'Free Smart Scale',
        desc: 'Track weight and body metrics to stay on top of your liver health goals',
      },
      {
        image: NutritionistImage,
        title: 'Free Nutritionist Session',
        desc: 'Get personalized guidance from nutritionists to improve your liver health',
      },
      {
        image: PhysiotherapistImage,
        title: 'Free Physiotherapist session',
        desc: 'Receive expert physiotherapy sessions tailored to enhance your liver health',
      },
      {
        image: LipaglynImage,
        title: 'Free Lipaglyn Strips',
        desc: 'Get doctor-prescribed strips to support better liver and metabolic health',
      },
    ],

    faqs: [
      {
        question: 'How do I access the Liver Forever Program?',
        answer:
          'Scan the QR code on your Lipaglyn pack to download the app and activate the program.',
      },
      {
        question: 'What benefits do I get with the Liver Forever Program?',
        answer:
          'With the Liver Forever Program, you get free consultations with a physiotherapist, nutritionist, and success coach, along with complimentary Lipaglyn strips, a smart scale, and expert-curated educational content to support your health journey.',
      },
      {
        question: 'How long do the benefits last?',
        answer:
          'The benefits last for 1 month. You can renew your benefits with every new Lipaglyn purchase.',
      },
      {
        question: 'Is my information secure?',
        answer:
          'Yes, your information is completely secure. Protecting your privacy and data is our top priority, and we follow strict safety protocols to keep it safe.',
      },
    ],
  },

  [constants.CARE_PROGRAM_TYPE.VIEMAX]: VIEMAX,

  [constants.CARE_PROGRAM_TYPE.NIVOLUMAB]: ANAYA_CONFIG,
  [constants.CARE_PROGRAM_TYPE.ANAYA]: ANAYA_CONFIG,

  [constants.CARE_PROGRAM_TYPE.DIASENS]: DIASENS_CONFIG,
  [constants.CARE_PROGRAM_TYPE.GOODFLIP]: GOODFLIP_CONFIG,
  [constants.CARE_PROGRAM_TYPE.GLUCOLIVE]: GLUCOLIVE_CONFIG,
}
